import React from "react";

const FacilityDocumentsTab: React.FC = () => {
  return (
    <div className="cx-max-w-[960px] cx-mx-auto cx-px-4 sm:cx-px-6">
      <div className="cx-py-8">
        <div className="cx-bg-white cx-rounded-lg cx-shadow-sm cx-border cx-border-neutral-light cx-p-6">
          <h2 className="cx-text-xl cx-font-semibold cx-text-text-primary cx-mb-4">
            Documents
          </h2>
          <p className="cx-text-text-secondary">
            Documents content coming soon.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FacilityDocumentsTab;
